(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Observable = require('./Observable');

var _Observable2 = _interopRequireDefault(_Observable);

var _Flock2 = require('../../common/Flock');

var _Flock3 = _interopRequireDefault(_Flock2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FlockObservable = function (_Flock) {
  _inherits(FlockObservable, _Flock);

  function FlockObservable() {
    _classCallCheck(this, FlockObservable);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(FlockObservable).call(this));

    _this.observable = new _Observable2.default(_this);
    return _this;
  }

  _createClass(FlockObservable, [{
    key: 'registerObserver',
    value: function registerObserver(observer) {
      this.observable.registerObserver(observer);
    }
  }, {
    key: 'notifyObservers',
    value: function notifyObservers() {
      this.observable.notifyObservers();
    }
  }]);

  return FlockObservable;
}(_Flock3.default);

exports.default = FlockObservable;

},{"../../common/Flock":10,"./Observable":2}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _QuackObservable2 = require('./QuackObservable');

var _QuackObservable3 = _interopRequireDefault(_QuackObservable2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Observable = function (_QuackObservable) {
  _inherits(Observable, _QuackObservable);

  function Observable(duck) {
    _classCallCheck(this, Observable);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Observable).call(this));

    _this.observers = [];
    _this.duck = duck;
    return _this;
  }

  _createClass(Observable, [{
    key: 'registerObserver',
    value: function registerObserver(observer) {
      this.observers.push(observer);
    }
  }, {
    key: 'notifyObservers',
    value: function notifyObservers() {
      var iterator = this.observers[Symbol.iterator]();
      while (iterator.hasNext()) {
        var observer = iterator.next();
        observer.update(this.duck);
      }
    }
  }]);

  return Observable;
}(_QuackObservable3.default);

exports.default = Observable;

},{"./QuackObservable":4}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Observer = function () {
  function Observer() {
    _classCallCheck(this, Observer);
  }

  _createClass(Observer, [{
    key: "update",
    value: function update() {
      throw new Error("This method must be overwritten!");
    }
  }]);

  return Observer;
}();

exports.default = Observer;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QuackObservable = function () {
  function QuackObservable() {
    _classCallCheck(this, QuackObservable);
  }

  _createClass(QuackObservable, [{
    key: "registerObserver",
    value: function registerObserver() {
      throw new Error("This method must be overwritten!");
    }
  }, {
    key: "notifyObservers",
    value: function notifyObservers() {
      throw new Error("This method must be overwritten!");
    }
  }]);

  return QuackObservable;
}();

exports.default = QuackObservable;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Observer2 = require("./Observer");

var _Observer3 = _interopRequireDefault(_Observer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Quackologist = function (_Observer) {
  _inherits(Quackologist, _Observer);

  function Quackologist() {
    _classCallCheck(this, Quackologist);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Quackologist).apply(this, arguments));
  }

  _createClass(Quackologist, [{
    key: "update",
    value: function update(duck) {
      console.log("Quackologist: " + oDuck + "just quacked");
    }
  }]);

  return Quackologist;
}(_Observer3.default);

exports.default = Quackologist;

},{"./Observer":3}],6:[function(require,module,exports){
'use strict';

var _CountingDuckFactory = require('../../common/CountingDuckFactory');

var _CountingDuckFactory2 = _interopRequireDefault(_CountingDuckFactory);

var _Goose = require('../../common/Goose');

var _Goose2 = _interopRequireDefault(_Goose);

var _GooseAdapter = require('../../common/GooseAdapter');

var _GooseAdapter2 = _interopRequireDefault(_GooseAdapter);

var _Flock = require('./Flock');

var _Flock2 = _interopRequireDefault(_Flock);

var _Quackologist = require('./Quackologist');

var _Quackologist2 = _interopRequireDefault(_Quackologist);

var _QuackCounter = require('../../common/QuackCounter');

var _QuackCounter2 = _interopRequireDefault(_QuackCounter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var oDuckFactory = new _CountingDuckFactory2.default();
var oMallardDuck = oDuckFactory.createMallardDuck();
var oDuckCall = oDuckFactory.createDuckCall();
var oRedheadDuck = oDuckFactory.createRedheadDuck();
var oRubberDuck = oDuckFactory.createRubberDuck();
var oGoose = new _Goose2.default();
var oGooseAdapter = new _GooseAdapter2.default(oGoose);

var oFlockOfDucks = new _Flock2.default();
oFlockOfDucks.add(oMallardDuck);
oFlockOfDucks.add(oDuckCall);
oFlockOfDucks.add(oRedheadDuck);
oFlockOfDucks.add(oRubberDuck);
oFlockOfDucks.add(oGooseAdapter);

var oFlockOfMallards = new _Flock2.default();

var oMallardDuck1 = oDuckFactory.createMallardDuck();
var oMallardDuck2 = oDuckFactory.createMallardDuck();
var oMallardDuck3 = oDuckFactory.createMallardDuck();
var oMallardDuck4 = oDuckFactory.createMallardDuck();

oFlockOfMallards.add(oMallardDuck1);
oFlockOfMallards.add(oMallardDuck2);
oFlockOfMallards.add(oMallardDuck3);
oFlockOfMallards.add(oMallardDuck4);

oFlockOfDucks.add(oFlockOfMallards);

console.log("Duck simulator with Observer");

var oQuackologist = new _Quackologist2.default();

oFlockOfDucks.registerObserver(oQuackologist);

oFlockOfDucks.quack();

oFlockOfMallards.quack();

console.log(_QuackCounter2.default.getQuacks());

},{"../../common/CountingDuckFactory":8,"../../common/Goose":11,"../../common/GooseAdapter":12,"../../common/QuackCounter":14,"./Flock":1,"./Quackologist":5}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AbstractDuckFactory = function () {
  function AbstractDuckFactory() {
    _classCallCheck(this, AbstractDuckFactory);
  }

  _createClass(AbstractDuckFactory, [{
    key: "createMallardDuck",
    value: function createMallardDuck() {
      throw new Error("This method must be overwritten!");
    }
  }, {
    key: "createRedheadDuck",
    value: function createRedheadDuck() {
      throw new Error("This method must be overwritten!");
    }
  }, {
    key: "createDuckCall",
    value: function createDuckCall() {
      throw new Error("This method must be overwritten!");
    }
  }, {
    key: "createRubberDuck",
    value: function createRubberDuck() {
      throw new Error("This method must be overwritten!");
    }
  }]);

  return AbstractDuckFactory;
}();

exports.default = AbstractDuckFactory;

},{}],8:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AbstractDuckFactory2 = require('./AbstractDuckFactory');

var _AbstractDuckFactory3 = _interopRequireDefault(_AbstractDuckFactory2);

var _QuackCounter = require('./QuackCounter');

var _QuackCounter2 = _interopRequireDefault(_QuackCounter);

var _MallardDuck = require('./MallardDuck');

var _MallardDuck2 = _interopRequireDefault(_MallardDuck);

var _RedheadDuck = require('./RedheadDuck');

var _RedheadDuck2 = _interopRequireDefault(_RedheadDuck);

var _DuckCall = require('./DuckCall');

var _DuckCall2 = _interopRequireDefault(_DuckCall);

var _RubberDuck = require('./RubberDuck');

var _RubberDuck2 = _interopRequireDefault(_RubberDuck);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CountingDuckFactory = function (_AbstractDuckFactory) {
  _inherits(CountingDuckFactory, _AbstractDuckFactory);

  function CountingDuckFactory() {
    _classCallCheck(this, CountingDuckFactory);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(CountingDuckFactory).apply(this, arguments));
  }

  _createClass(CountingDuckFactory, [{
    key: 'createMallardDuck',
    value: function createMallardDuck() {
      return new _QuackCounter2.default(new _MallardDuck2.default());
    }
  }, {
    key: 'createRedheadDuck',
    value: function createRedheadDuck() {
      return new _QuackCounter2.default(new _RedheadDuck2.default());
    }
  }, {
    key: 'createDuckCall',
    value: function createDuckCall() {
      return new _QuackCounter2.default(new _DuckCall2.default());
    }
  }, {
    key: 'createRubberDuck',
    value: function createRubberDuck() {
      return new _QuackCounter2.default(new _RubberDuck2.default());
    }
  }]);

  return CountingDuckFactory;
}(_AbstractDuckFactory3.default);

exports.default = CountingDuckFactory;

},{"./AbstractDuckFactory":7,"./DuckCall":9,"./MallardDuck":13,"./QuackCounter":14,"./RedheadDuck":16,"./RubberDuck":17}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Quackable2 = require('./Quackable');

var _Quackable3 = _interopRequireDefault(_Quackable2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DuckCall = function (_Quackable) {
  _inherits(DuckCall, _Quackable);

  function DuckCall() {
    _classCallCheck(this, DuckCall);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(DuckCall).apply(this, arguments));
  }

  _createClass(DuckCall, [{
    key: 'quack',
    value: function quack() {
      console.log('Kwak!');
    }
  }]);

  return DuckCall;
}(_Quackable3.default);

exports.default = DuckCall;

},{"./Quackable":15}],10:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Quackable2 = require('./Quackable');

var _Quackable3 = _interopRequireDefault(_Quackable2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Flock = function (_Quackable) {
  _inherits(Flock, _Quackable);

  function Flock() {
    _classCallCheck(this, Flock);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Flock).call(this));

    _this.quackers = [];
    return _this;
  }

  _createClass(Flock, [{
    key: 'quack',
    value: function quack() {
      var iterator = this.quackers[Symbol.iterator]();
      var quacker = iterator.next();

      while (quacker.value) {
        quacker.value.quack();
        quacker = iterator.next();
      }
    }
  }, {
    key: 'add',
    value: function add(quackable) {
      this.quackers.push(quackable);
    }
  }]);

  return Flock;
}(_Quackable3.default);

exports.default = Flock;

},{"./Quackable":15}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Goose = function () {
  function Goose() {
    _classCallCheck(this, Goose);
  }

  _createClass(Goose, [{
    key: "honk",
    value: function honk() {
      console.log("Honk!");
    }
  }]);

  return Goose;
}();

exports.default = Goose;

},{}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GooseAdapter = function () {
  function GooseAdapter(oGoose) {
    _classCallCheck(this, GooseAdapter);

    this.oGoose = oGoose;
  }

  _createClass(GooseAdapter, [{
    key: "quack",
    value: function quack() {
      this.oGoose.honk();
    }
  }]);

  return GooseAdapter;
}();

exports.default = GooseAdapter;

},{}],13:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Quackable2 = require('./Quackable');

var _Quackable3 = _interopRequireDefault(_Quackable2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MallardDuck = function (_Quackable) {
  _inherits(MallardDuck, _Quackable);

  function MallardDuck() {
    _classCallCheck(this, MallardDuck);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(MallardDuck).apply(this, arguments));
  }

  _createClass(MallardDuck, [{
    key: 'quack',
    value: function quack() {
      console.log('Quack!');
    }
  }]);

  return MallardDuck;
}(_Quackable3.default);

exports.default = MallardDuck;

},{"./Quackable":15}],14:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Quackable2 = require('./Quackable');

var _Quackable3 = _interopRequireDefault(_Quackable2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var counter = 0;

var QuackCounter = function (_Quackable) {
  _inherits(QuackCounter, _Quackable);

  function QuackCounter(duck) {
    _classCallCheck(this, QuackCounter);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(QuackCounter).call(this));

    counter = 0;
    _this.duck = duck;
    return _this;
  }

  _createClass(QuackCounter, [{
    key: 'quack',
    value: function quack() {
      this.duck.quack();
      counter++;
    }
  }], [{
    key: 'getQuacks',
    value: function getQuacks() {
      return counter;
    }
  }, {
    key: 'quacks',
    get: function get() {
      return counter;
    }
  }]);

  return QuackCounter;
}(_Quackable3.default);

exports.default = QuackCounter;

},{"./Quackable":15}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Quackable = function () {
  function Quackable() {
    _classCallCheck(this, Quackable);
  }

  _createClass(Quackable, [{
    key: "quack",
    value: function quack() {
      throw new Error("This method must be overwritten!");
    }
  }]);

  return Quackable;
}();

exports.default = Quackable;

},{}],16:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Quackable2 = require('./Quackable');

var _Quackable3 = _interopRequireDefault(_Quackable2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RedheadDuck = function (_Quackable) {
  _inherits(RedheadDuck, _Quackable);

  function RedheadDuck() {
    _classCallCheck(this, RedheadDuck);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(RedheadDuck).apply(this, arguments));
  }

  _createClass(RedheadDuck, [{
    key: 'quack',
    value: function quack() {
      console.log('Quack!');
    }
  }]);

  return RedheadDuck;
}(_Quackable3.default);

exports.default = RedheadDuck;

},{"./Quackable":15}],17:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Quackable2 = require('./Quackable');

var _Quackable3 = _interopRequireDefault(_Quackable2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RubberDuck = function (_Quackable) {
  _inherits(RubberDuck, _Quackable);

  function RubberDuck() {
    _classCallCheck(this, RubberDuck);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(RubberDuck).apply(this, arguments));
  }

  _createClass(RubberDuck, [{
    key: 'quack',
    value: function quack() {
      console.log('Squeak!');
    }
  }]);

  return RubberDuck;
}(_Quackable3.default);

exports.default = RubberDuck;

},{"./Quackable":15}]},{},[6])

